// extracted by mini-css-extract-plugin
export default {"tab-navigation__list":"TabNavigation_tab-navigation__list__5nzus","tab-navigation__right-side":"TabNavigation_tab-navigation__right-side__b0E83"};